export const UPDATE_IPSAFE_LIST_CLICKHOUSE = 'UPDATE_IPSAFE_LIST_CLICKHOUSE'
export const DELETE_CLICKHOUSE = 'DELETE_CLICKHOUSE'
